/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 出荷数量18
 * @export
 * @interface Col18
 */
export interface Col18 {
}

/**
 * Check if a given object implements the Col18 interface.
 */
export function instanceOfCol18(value: object): value is Col18 {
    return true;
}

export function Col18FromJSON(json: any): Col18 {
    return Col18FromJSONTyped(json, false);
}

export function Col18FromJSONTyped(json: any, ignoreDiscriminator: boolean): Col18 {
    return json;
}

export function Col18ToJSON(json: any): Col18 {
    return Col18ToJSONTyped(json, false);
}

export function Col18ToJSONTyped(value?: Col18 | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

